module.exports = __webpack_public_path__ + "img/humanImg4.fe386b94.png";